import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { BerichtQuerySorterConfig } from 'fa-kt.types';
import { BerichtService } from '../service';

@Component({
  selector: 'fa-kt-bericht-sorter',
  templateUrl: './bericht-sorter.component.html',
  styleUrls: ['./bericht-sorter.component.css'],
})
export class BerichtSorterComponent {
  public BerichtSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public bericht: BerichtService,
  ) {
    this.BerichtSorterConfig = BerichtQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
